<script lang="ts">
    import bgOverlay from '@src/assets/img/bg_overlay.webp';
</script>

<img
    src={bgOverlay}
    alt="background"
    class="absolute left-0 top-0 z-[-1] h-full w-full bg-black object-cover phone:top-0 phone:h-full"
/>
